import * as types from "./types";

export default {
  [types.PAGE_TITLE]: state => {
    return state.pageTitle;
  },
  [types.OVERLAY]: state => {
    return state.overlay;
  },
  [types.COLLAPSE]: state => {
    return state.collapse;
  }
};
